import React from 'react';
import { Select, Group, Avatar, Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { getLowerCaseString } from '../../helpers/StringFormatHelper';


export default function LeagueSelect({ value, onChange, label = 'League', size = 'sm' }) {
    const leagues = useSelector((state) => state.Utility.coverageCompetitions);
  
    const data =
      (leagues ?? [])
        .filter((item) => getLowerCaseString(item?.type) === 'league')
        .map((item) => ({
          value: String(item.competitionId),
          label: item.name,
          name: item.name,
          logo: item.logo,
          country: item.country,
        }));
  
    const loading = false;
  
    return (
      <Select
        label={label}
        value={value}
        onChange={onChange}
        data={data}
        searchable
        clearable
        rightSectionWidth={42}
        size={size}
        placeholder="Pick a league"
        itemComponent={({ name, country, logo, ...others }) => (
          <Group {...others} wrap="nowrap" gap="sm">
            <Avatar src={logo} radius="sm" size="sm" />
            <div>
              <Text size="sm" fw={600}>{name}</Text>
              {country && <Text size="xs" c="dimmed">{country?.name}</Text>}
            </div>
          </Group>
        )}
        renderOption={({ option }) => (
          <Group wrap="nowrap" gap="sm">
            <Avatar src={option.logo} radius="sm" size="sm" />
            <Text size="sm">{option.name}</Text>
          </Group>
        )}
        nothingFound="No leagues"
        disabled={loading}
      />
    );
  }
  